'use strict';

var FileDownloader = require('./FileDownloader');
require('./KayleeService');
var log = require('../../log/Log').channel('MimoService');

/* global AveoDevice */
/* global AveoExec */
/* global AveoPackageInfo */
/* global AveoPackageInstaller */
/* global AveoPermissions */

angular.module('inara').factory('MimoService', MimoService);

MimoService.$inject = ['$q', '$timeout', 'KayleeService'];

function MimoService($q, $timeout, KayleeService) {
    var platformInfo;
    var kioskModeEnabled;

    return {
        initialize: initialize,
        name: 'mimo',
        caps: {
            hasAllowOtaUpgrade: false,
            hasBattery: false,
            hasKioskModeEnable: true,
            hasRestartDevice: true,
            hasRestartInara: true,
        },
        getFactoryInstallChecklist: getFactoryInstallChecklist,
        getSerialNumber: getSerialNumber,
        finishUpdates: finishUpdates,
        needsSystemUpdate: needsSystemUpdate,
        requiredPermissions: [
            'ACCESS_COARSE_LOCATION',
            'ACCESS_FINE_LOCATION',
            'READ_EXTERNAL_STORAGE',
            'WRITE_EXTERNAL_STORAGE',
        ],
        restartDevice: restartDevice,
        setKioskMode: setKioskMode,
        setRgbLeds: setRgbLeds,
        setWake: setWake,
        setSleep: setSleep,
        uninstallApplication: uninstallApplication,
        updateApplication: updateApplication,
        updateSystem: updateSystem,
    };

    function finishUpdates(updates) {
        var needToReboot = false;

        updates.forEach(function(update) {
            if ((update.type === 'apk' || update.type === 'uninstallApk') &&
                update.isSystem) {
                needToReboot = true;
            }
        });

        if (needToReboot) {
            log.info('updates require reboot, starting now...');
            return mimoCommand('reboot_device');
        }

        log.info('reboot not required after updates');
        return $q.resolve();
    }

    function restartDevice(delayMs) {
        if (typeof delayMs === 'undefined') delayMs = 1000;
        $timeout(function() { mimoCommand('reboot_device'); }, delayMs);
    }

    function getFactoryInstallChecklist() {
        return [{
            name: 'Inara is device owner',
            getState: function() {
                return AveoDevice.isDeviceOwner()
                .then(function(isDeviceOwner) {
                    return isDeviceOwner ? 'yes' : 'no';
                });
            },
        }, {
            name: 'Inara is device administrator',
            getState: function() {
                return AveoDevice.getDeviceAdminActiveForComponent(
                    'com.aveosystems.inara', 'com.aveosystems.AveoDeviceDeviceAdminReceiver')
                .then(function(deviceAdminActive) {
                    return deviceAdminActive ? 'yes' : 'no';
                });
            },
        }, {
            name: 'Wash is launcher',
            getState: function() {
                return AveoDevice.getLauncher()
                .then(function(packageName) {
                    return packageName === 'com.aveosystems.launcher' ? 'yes' : 'no';
                });
            },
        }, {
            name: 'Location permissions',
            getState: function() {
                return AveoPermissions.checkPermissions([ 'ACCESS_COARSE_LOCATION', 'ACCESS_FINE_LOCATION' ])
                .then(function(hasPermission) {
                    for (var i = 0; i < hasPermission.length; i++) {
                        if (!hasPermission[i]) return 'no';
                    }

                    return 'yes';
                });
            },
        }, {
            name: 'Storage permissions',
            getState: function() {
                return AveoPermissions.checkPermissions([ 'READ_EXTERNAL_STORAGE', 'WRITE_EXTERNAL_STORAGE' ])
                .then(function(hasPermission) {
                    for (var i = 0; i < hasPermission.length; i++) {
                        if (!hasPermission[i]) return 'no';
                    }

                    return 'yes';
                });
            },
        }, {
            name: 'Mimo Service installed',
            getState: function() {
                return $q(function(resolve, reject) {
                    AveoPackageInfo.getPackageInfo('com.phoneserver.phoneservercode',
                        function(pinfo) { resolve('yes'); },
                        function(err) { resolve('no'); }
                    );
                });
            },
        }, {
            name: 'MLock & Mimo Control Uninstalled',
            getState: function() {
                var pkgs = ['com.memomonitors.mlock', 'com.zd.zdplayer', 'com.moki.android.kiosk'];

                return $q.all(pkgs.map(function(pkg) {
                    return $q(function(resolve, reject) {
                        AveoPackageInfo.getPackageInfo(pkg,
                            function(pinfo) { resolve(true); },
                            function(err) { resolve(false); }
                        );
                    });
                }))
                .then(function(results) {
                    var found = results.reduce(function(acc, curr) {
                        return acc || curr;
                    }, false);

                    return found ? 'no' : 'yes';
                });
            },
        }, {
            name: 'Developer options disabled',
            getState: function() {
                return AveoDevice.getDeveloperOptions()
                .then(function(devOptions) {
                    var adbEnabled = devOptions.adbEnabled === '1';
                    var devEnabled = devOptions.developmentSettingsEnabled === '1';
                    return adbEnabled || devEnabled ? 'no' : 'yes';
                });
            },
        }, {
            name: 'Kiosk mode enabled',
            getState: function() {
                return $q.resolve(kioskModeEnabled ? 'yes' : 'no');
            },
        }];
    }

    function getSerialNumber() {
        return platformInfo.serial;
    }

    function initialize(pinfo) {
        log.debug('initializing');

        var pkg = 'com.phoneserver.phoneservercode';
        platformInfo = pinfo;

        return $q(function(resolve, reject) {
            AveoPackageInfo.getPackageInfo(pkg, function(pkgInfo) {
                log.info('found Mimo Service version ' + pkgInfo.versionName);
                pinfo.mimo = { mimoService: pkgInfo.versionName };
                resolve();
            }, function (err) {
                log.error('Mimo Service not installed');
                resolve();
            });
        })
        .then(function() {
            log.info('setting home activity to Aveo Systems Launcher');
            return AveoDevice.setHomeActivity('com.aveosystems.launcher', '.LauncherActivity');
        })
        .then(function() {
            log.info('setting lock task packages');
            return AveoDevice.setLockTaskPackages();
        })
        .then(function() {
            return setKioskMode(true);
        });
    }

    function mimoCommand(command) {
        var req = new XMLHttpRequest();
        var url = 'http://localhost:8081/' + command;
        var deferredPromise = {};
        var params = Array.prototype.slice.call(arguments, 1);

        deferredPromise.promise = $q(function(resolve, reject) {
            deferredPromise.resolve = resolve;
            deferredPromise.reject = reject;
        });

        params.forEach(function(param, index) {
            if (index % 2 === 0) {
                url += index === 0 ? '?' : '&';
                url += param;
            } else {
                url += '=' + param; // don't use encodeURIComponent
            }
        });

        log.debug('url = ' + url);

        req.addEventListener('abort', function(e) {
            var message = command + ' aborted: ' + JSON.stringify(e);
            log.error(message);
            deferredPromise.reject(new Error(message));
        });
        req.addEventListener('error', function(e) {
            var message = command + ' error: ' + JSON.stringify(e);
            log.error(message);
            deferredPromise.reject(new Error(message));
        });
        req.addEventListener('timeout', function(e) {
            var message = command + ' timeout: ' + JSON.stringify(e);
            log.error(message);
            deferredPromise.reject(new Error(message));
        });
        req.addEventListener('load', function(e) {
            var data;

            try {
                data = JSON.parse(req.responseText);
            } catch (err) {
                data = req.responseText;
            }

            var message = command + ' load: ' + JSON.stringify(data, null, 4);
            log.debug(message);
            deferredPromise.resolve(data);
        });
        req.open('GET', url);
        req.timeout = 1000;
        req.send();

        return deferredPromise.promise;
    }

    function needsSystemUpdate(update) {
        if (update.versionName !== platformInfo.display) {
            return { fromVersion: platformInfo.display, toVersion: update.versionName };
        }

        return false;
    }

    function setKioskMode(enable) {
        kioskModeEnabled = enable;
        return enable ? AveoDevice.startLockTask() : AveoDevice.stopLockTask();
    }

    function setRgbLeds(red, green, blue) { // inputs 0-255
        red = Math.floor(0.5 * red).toString(16);
        if (red.length < 2) red = '0' + red;

        green = Math.floor(0.5 * green).toString(16);
        if (green.length < 2) green = '0' + green;

        blue = Math.floor(0.5 * blue).toString(16);
        if (blue.length < 2) blue = '0' + blue;

        return mimoCommand('light', 'led', red + green + blue);
    }

    function setSleep() {
        return mimoCommand('setBrightness', 'intensity', '0')
        .then($q.resolve, $q.resolve);
    }

    function setWake() {
        return mimoCommand('setBrightness', 'intensity', '192')
        .then($q.resolve, $q.resolve);
    }

    function uninstallApplication(update) {
        return AveoPackageInstaller.uninstall(update.packageName);
    }

    function updateApplication(update, onProgress) {
        var dest = cordova.file.externalDataDirectory + update.dest;

        return FileDownloader.download(update.apkUri, dest, onProgress)
        .then(function() {
            // Get absolute path.
            // FIXME: This should probably be done with
            // window.resolveLocalFileSystemURL, but the implementation is
            // quirky, so for now I'm hacking it by just removing 'file://'
            // from the beginning.

            var apkPath = dest.slice(7);

            return AveoPackageInstaller.install(update.packageName, apkPath);
        });
    }

    function updateSystem(update, onProgress) {
        log.info('downloading system image from ' + update.uri);

        return mimoCommand('downloadFirmware', 'url', update.uri)
        .then(function() {
            return $q(function(resolve, reject) {
                $timeout(function() {
                    waitForSystemImageDownload(resolve, reject, onProgress);
                }, 3000);
            });
        })
        .then(function() {
            log.info('system image download complete');

            // Wait for Mimo Service to finish copying file to /data.

            return $q(function(resolve, reject) {
                $timeout(resolve, 10000);
            });
        })
        .then(function() {
            log.info('starting system image update');
            return mimoCommand('updateFirmware');
        })
        .then(function() {
            log.info('waiting for system image update');

            return $q(function(resolve, reject) {
                // never resolve -- the device will reboot as part of the system image update
            });
        });
    }

    function waitForSystemImageDownload(resolve, reject, onProgress) {
        AveoExec.exec('stat /sdcard/Download/update.zip')
        .then(function(res) {
            if (res.status === 0) {
                var match = /size:\s*(\d+)\s+blocks:\s*(\d+)/i.exec(res.output);

                if (match) {
                    var progress = parseInt(match[2], 10) * 512 / parseInt(match[1], 10);
                    onProgress(progress);
                }

                return;
            }

            log.error('unexpected result from stat: ' + JSON.stringify(res));
        })
        .catch(function(err) {
            log.error('error from stat: ' + JSON.stringify(err));
            return $q.resolve();
        })
        .then(function() {
            return mimoCommand('isFirmwareFileDownloaded');
        })
        .then(function(data) {
            if (data.hasOwnProperty('Message') && data.Message === 'Firmware file exists.') {
                resolve();
            } else {
                $timeout(function() {
                    waitForSystemImageDownload(resolve, reject, onProgress);
                }, 3000);
            }
        });
    }
}

module.exports = MimoService;
